import Vue from 'vue';
import Vuex from 'vuex';
import createVuexAlong from "vuex-along";
import tabs from "./modules/tabs";
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters'

Vue.use(Vuex);
const modules = {
  tabs,
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules,
  plugins: [
    createVuexAlong({
      name: "land-login",
      justSession: false,
      local: {
        list: [
          "userInfo",
          "menus",
          "initAuthTreeData",
          "authButtonList",
          "updatePwdOriginErrorCount",
          "tabs.tabs",
          "role",
          "areaList"
        ],
      },
    }),
  ],
});
